/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_ApprovalProcessDto } from '../models/PagedResultDto_ApprovalProcessDto';
import type { Wealthlane_CustomerService_Dtos_ApprovalProcess_ApprovalProcessDto } from '../models/Wealthlane_CustomerService_Dtos_ApprovalProcess_ApprovalProcessDto';
import type { Wealthlane_CustomerService_Dtos_ApprovalProcess_CreateUpdateApprovalProcessDto } from '../models/Wealthlane_CustomerService_Dtos_ApprovalProcess_CreateUpdateApprovalProcessDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ApprovalProcessService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_ApprovalProcess_ApprovalProcessDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppApprovalProcessApprovalProcess(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_ApprovalProcess_ApprovalProcessDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/approval-process/approval-process',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_ApprovalProcess_ApprovalProcessDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppApprovalProcess(
        requestBody?: Wealthlane_CustomerService_Dtos_ApprovalProcess_CreateUpdateApprovalProcessDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_ApprovalProcess_ApprovalProcessDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/approval-process',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_ApprovalProcessDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppApprovalProcess(
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_ApprovalProcessDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/approval-process',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_ApprovalProcess_ApprovalProcessDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppApprovalProcess(
        id: string,
        requestBody?: Wealthlane_CustomerService_Dtos_ApprovalProcess_CreateUpdateApprovalProcessDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_ApprovalProcess_ApprovalProcessDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/approval-process/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppApprovalProcess(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/approval-process/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_CustomerService_Dtos_ApprovalProcess_ApprovalProcessDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppApprovalProcess1(
        id: string,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_ApprovalProcess_ApprovalProcessDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/approval-process/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
